import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const sections = [
  {
    title: "1. Introduction",
    content: [
      'This Privacy Policy explains how Trevionix LTD ("Company", "we", "our", or "us") collects, uses, and protects personal data when you use our website, mobile applications, and related services (collectively, the "Service").',
      "Registered Office: International House, 12 Constance Street, London, E16 2DQ, United Kingdom. Email: support@trevionics.com. Phone: +44 7520 658798.",
      "We process personal data in accordance with applicable laws, including UK GDPR and other relevant data protection regulations.",
      "By using the Service, you agree to this Privacy Policy.",
    ],
  },
  {
    title: "2. Information We Collect",
    content: [
      "We may collect the following types of information:",
      "a. Personal Information — Name (if provided), email address, phone number (if provided), information submitted via forms or support requests.",
      "b. Usage and Technical Data — Device type and operating system, app version, IP address (or approximate location derived from it), app interactions and usage statistics, crash reports and diagnostics.",
      "c. Support and Communication Data — Messages sent via email or support forms, customer support interactions.",
      "d. Tracking and Analytics Data — We may use analytics tools to understand how users interact with the Service. We do not collect personally identifiable data for tracking without user consent.",
    ],
  },
  {
    title: "3. How We Use Information",
    content: [
      "We use collected data to:",
      "a. Provide and Maintain the Service — Deliver functionality, respond to user requests, provide customer support.",
      "b. Improve Performance — Analyze usage trends, fix bugs and improve stability, enhance user experience.",
      "c. Communication — Respond to inquiries, send important service-related updates.",
      "d. Security and Compliance — Prevent fraud and misuse, enforce Terms of Use, comply with legal obligations.",
      "e. Marketing (if applicable) — We may send marketing communications only with your explicit consent. You can opt out at any time.",
    ],
  },
  {
    title: "4. Legal Basis for Processing",
    content: [
      "We process data based on:",
      "Consent — where required (e.g., tracking, marketing).",
      "Legitimate Interests — to operate and improve the Service.",
      "Legal Obligations — where required by law.",
      "Contractual Necessity — to provide requested services.",
    ],
  },
  {
    title: "5. Sharing of Information",
    content: [
      "We may share data with:",
      "a. Service Providers — Third parties that support the Service, such as hosting providers, analytics services, and customer support tools. They are required to process data securely and only for specified purposes.",
      "b. Legal Requirements — We may disclose data if required by law or to protect rights and safety.",
      "c. Business Transfers — In case of merger or acquisition, data may be transferred under the same protections.",
      "d. With Your Consent — We may share data where you explicitly agree.",
      "We do not sell personal data.",
    ],
  },
  {
    title: "6. Data Retention",
    content: [
      "We retain data only as long as necessary to: provide the Service, comply with legal obligations, resolve disputes.",
    ],
  },
  {
    title: "7. Data Security",
    content: [
      "We implement appropriate safeguards, including: secure storage and encryption where applicable, access controls, monitoring against unauthorized access.",
      "However, no system can guarantee complete security.",
    ],
  },
  {
    title: "8. Your Rights",
    content: [
      "You may have the right to: access your data, correct inaccurate data, request deletion, restrict or object to processing, request data portability.",
      "To exercise your rights: support@trevionics.com.",
    ],
  },
  {
    title: "9. Analytics and Tracking (App Store Compliance)",
    content: [
      "We may use analytics tools to understand app usage and improve performance.",
      "Where required by law or platform rules (including iOS): tracking is performed only with user consent; users may control tracking permissions via device settings; we do not track users across apps or websites owned by other companies without permission.",
    ],
  },
  {
    title: "10. International Data Transfers",
    content: [
      "Your data may be processed outside your country.",
      "We ensure appropriate safeguards in accordance with applicable laws.",
    ],
  },
  {
    title: "11. Children's Privacy",
    content: [
      "The Service is not intended for individuals under 16.",
      "We do not knowingly collect data from children.",
    ],
  },
  {
    title: "12. Changes to this Policy",
    content: [
      "We may update this Privacy Policy.",
      "Updates will be posted with a revised date.",
    ],
  },
  {
    title: "13. Contact",
    content: [
      "Trevionix LTD",
      "International House",
      "12 Constance Street",
      "London",
      "E16 2DQ",
      "United Kingdom",
      "Email: support@trevionics.com",
      "Phone: +44 7520 658798",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <main className="min-h-screen bg-[#0d0d0d]">
      <Navbar />

      <section className="w-full pt-36 pb-16 md:pt-44 md:pb-20 px-6 md:px-10 lg:px-16">
        <p
          className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Legal
        </p>
        <h1
          className="text-4xl md:text-5xl lg:text-[60px] font-extrabold text-white leading-[1.04] tracking-[-0.025em]"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Privacy Policy
        </h1>
      </section>

      <section className="w-full px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <div className="max-w-3xl">
          <div className="flex flex-col gap-8 text-white/60 text-base leading-relaxed" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            {sections.map((section) => (
              <div key={section.title}>
                <h2
                  className="text-lg font-bold text-white mb-3"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {section.title}
                </h2>
                {section.content.map((p, i) => (
                  <p key={i} className={i > 0 ? "mt-3" : ""}>{p}</p>
                ))}
              </div>
            ))}
          </div>

          <p className="mt-12 text-xs text-[#6C7278]" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            Last updated: May 2026
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}